import React, { useEffect, useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import SelectBox from './SelectBox';
import { Button } from 'react-bootstrap';
import { CLICK_ACTIONS } from '../utils/Constant';
import GridMap from './GridMap';
import { GOOGLE_MAP_KEY } from '../utils/Config';
import { APIProvider } from '@vis.gl/react-google-maps';
import {
  AssignGridDataType,
  ColXsMdType,
  IAgriGridType,
  MUILocationGridFilterType,
  ReportingManagerType,
} from '../utils/Types';
import { checkNullValue, getValueFromArrayObjectGrid } from '../utils/Util';
import MUILocationGridFilter from './MUILocationGridFilter';
type SNNUType = string | number | null | undefined;

interface IGridDetailsProps {
  options: any;
  selectedGridIds: any;
  selectedGridsDetails?: IAgriGridType[];
  onGridAction: (action: string) => void;
  onSelectChange: (event: any) => void;
  polygonPositionsArray: any[] | undefined;
  assignedgrids: any;
  reportingManagerDetails: ReportingManagerType;
  selectedUser?: AssignGridDataType | null;
  findGridsForPincode: (event?: SNNUType[]) => void;
  setSelectedGridPincode: (event: any) => void;
}

const colSize: ColXsMdType = {
  xs: 6,
  md: 3,
};

const GridDetails: React.FunctionComponent<IGridDetailsProps> = ({
  options,
  onGridAction,
  onSelectChange,
  selectedGridIds,
  polygonPositionsArray,
  selectedGridsDetails,
  assignedgrids,
  reportingManagerDetails,
  selectedUser,
  findGridsForPincode,
  setSelectedGridPincode,
}) => {
  const [locationData, setLocationData] = useState<MUILocationGridFilterType>({
    zone: '',
    state: '',
    district: '',
    city: [],
    pincode: [],
  });
  let filteredOptions = [...options];
  if (assignedgrids?.split(',')?.length) {
    const gridIds = assignedgrids?.split(',')?.map((num: any) => num.trim());
    filteredOptions = options.filter(
      (item: any) => !gridIds.includes(item.value)
    );
  }
  useEffect(() => {
    console.log('selectedGridsDetails', locationData, locationData?.pincode);
    if (locationData?.city && locationData.city.length > 0) {
      findGridsForPincode(locationData.city);
    }
    if (
      locationData?.city &&
      locationData.city.length == 0 &&
      locationData?.district?.toString()?.length
    ) {
      onSelectChange([]);
    }
    setSelectedGridPincode(locationData?.pincode);
  }, [locationData]);

  const getGridDetails = () => (
    <div className="pt-4 mx-4 border-top">
      {selectedUser?.candidateuniqueid?.substring(0, 2) !== 'CD' && (
        <div className="mt-4">
          <MUILocationGridFilter
            size={{
              zone: colSize,
              state: colSize,
              district: colSize,
              city: colSize,
            }}
            filterData={{
              zone: locationData.zone,
              state: locationData.state,
              district: locationData.district,
              city: locationData.city ?? [],
              pincode: locationData.pincode ?? [],
            }}
            setLocationFilter={(filter: MUILocationGridFilterType) => {
              setLocationData({
                ...locationData,
                zone: filter.zone,
                state: filter.state,
                district: filter.district,
                city: filter.city ?? [],
                pincode: filter.pincode ?? [],
              });
            }}
            required={true}
            includeCityAllOption={true}
          />
        </div>
      )}
      <Label className="mb-0 model-label-title">Grid Details</Label>
      <Row>
        <Col xs={12} md={6}>
          <Row>
            <Col xs={12} md={6}>
              <Label className="mb-0 model-label-name">Reporting Manager</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {selectedGridsDetails &&
                selectedGridsDetails.length > 0 &&
                selectedGridsDetails[0].state
                  ? checkNullValue(reportingManagerDetails?.reportingManager)
                  : '-'}
              </Label>
            </Col>
            <Col xs={12} md={6}>
              <Label className="mb-0 model-label-name">State Name</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {getValueFromArrayObjectGrid(selectedGridsDetails, 'state')}
              </Label>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={6}>
              <Label className="mb-0 model-label-name">Role</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {selectedGridsDetails &&
                selectedGridsDetails.length > 0 &&
                selectedGridsDetails[0].state
                  ? checkNullValue(reportingManagerDetails.reportingManagerRole)
                  : '-'}
              </Label>
            </Col>
            <Col xs={12} md={6}>
              <Label className="mb-0 model-label-name">Village Name</Label>
              <br />
              <Label className="mb-0 model-label-value">
                {getValueFromArrayObjectGrid(selectedGridsDetails, 'vname')}
              </Label>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12} md={8}>
              <Label className="mb-0 model-label-name">Grid</Label>
              <br />
              <SelectBox
                isMulti
                options={filteredOptions}
                className="css-select-model-bg w-100"
                onChange={onSelectChange}
                value={selectedGridIds}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={6} className="grid-map-parent">
          <APIProvider apiKey={GOOGLE_MAP_KEY}>
            <GridMap polygonPositionsArray={polygonPositionsArray} />
          </APIProvider>
        </Col>
      </Row>
      <div className="d-flex justify-content-center mt-4 mb-2">
        <Button
          variant="primary"
          className="m-1 cl-btn-primary"
          onClick={() => {
            onGridAction(CLICK_ACTIONS.ASSIGN_GRID);
          }}
        >
          Assign Grid
        </Button>
      </div>
    </div>
  );
  return getGridDetails();
};
export default GridDetails;
